__turbopack_context__.v({
  "className": "inter_c4f53213-module__aSIzna__className",
  "variable": "inter_c4f53213-module__aSIzna__variable",
});
